export class UserSessionStorageMergeRequest {
  userId?: number;
  deviceType?: string;
  key?: string;
  value?: string;
}
